<template>
  <div class="expenses-page">
    <PageHeader
      :title="title"
      :subtitle="subtitle"
      :actions="actions"
      @action="emitAction"
    >
      <template v-if="$slots.actions" #actions>
        <slot name="actions" :actions="actions" :on-action="emitAction"></slot>
      </template>
    </PageHeader>

    <div class="expenses-content">
      <slot name="content">
        <slot name="metrics"></slot>
        <slot name="toolbar"></slot>
        <slot name="table"></slot>
      </slot>
    </div>

    <slot name="modal"></slot>
  </div>
</template>

<script>
import PageHeader from '@/components/common/PageHeader.vue';

export default {
  name: 'ExpensesPageShell',
  components: {
    PageHeader,
  },
  props: {
    title: {
      type: String,
      default: 'Gastos',
    },
    subtitle: {
      type: String,
      default: '',
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['action'],
  methods: {
    emitAction(action) {
      this.$emit('action', action);
    },
  },
};
</script>

<style scoped>
.expenses-page {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.expenses-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

@media (max-width: 767px) {
  .expenses-content {
    padding: 12px;
  }
}
</style>
